import { Setting } from '../types/constant/PagesPropsType';
import { useCallback, useEffect, useState } from 'react';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

/** getSubscription の取得結果（詳細画面のリダイレクト判定などに使用） */
export type SubscriptionFetchStatus = 'loading' | 'success' | 'error';

/**
 * 画面表示時に定期購買情報を取得する
 *
 * @param setting
 * @param subscriptionId
 */
export const useSubscriptionDetail = (setting: Setting, subscriptionId: string) => {
  const [subscription, setSubscription] = useState<SubscriptionApiType>();
  const [subscriptionFetchStatus, setSubscriptionFetchStatus] =
    useState<SubscriptionFetchStatus>('loading');

  const fetchSubscription = useCallback(() => {
    setSubscriptionFetchStatus('loading');

    axios
      .post(
        `${CUSTOMER_API_URL}?action=getSubscription`,
        { subscriptionId },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        const data = response.data as SubscriptionApiType;

        // メンテ等で空 JSON や契約ID欠損のみ検知。それ以外の不整合は検証せず表示する（仕様に合わせてトップへ）
        if (!data?.subscriptionContractId) {
          setSubscriptionFetchStatus('error');
          return;
        }

        if (data.subscriptionLines?.length) {
          data.subscriptionLines = [...data.subscriptionLines].sort((a, b) =>
            (a.variantId ?? '').localeCompare(b.variantId ?? '')
          );
        }
        setSubscription(data);
        setSubscriptionFetchStatus('success');
      })
      .catch((e) => {
        console.log(e);
        setSubscriptionFetchStatus('error');
      });
  }, [setting.token, subscriptionId]);

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  return {
    subscription,
    setSubscription,
    fetchSubscription,
    subscriptionFetchStatus,
  };
};
